import { React, useState } from 'react';
import { signUp, confirmSignUp } from 'aws-amplify/auth';
// import UserPool from '../UserPool.js'
import {
  Container,
  FormWrap,
  FormContent,
  Form,
  FormH1,
  FormLabel,
  FormInput,
  FormButton,
  Text,
  NavBtnLink,
  SignUpTermsContainer,
  Checkbox,
  CheckboxText,
  ErrorText
} from '../SignIn/SigninElements.js';

const SignUp = () => {

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [name, setName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [address, setAddress] = useState('');
  const [termsAffirmed, setTermsAffirmed] = useState(false);
  const [verStatus, setVerStatus] = useState(false);
  const [confirmCode, setConfirmCode] = useState('')
  const [confirmStatus, setConfirmStatus] = useState(false);

  const handleSignUp = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    try {
      const { user } = await signUp({
        username: email,
        password,
        attributes: {
          email: email,
          'name.formatted': name,
        }
      });
      console.log('Sign up successful!', user);
      setError('')
      setVerStatus(true);
    } catch (error) {
      console.error('Error signing up:', error);
      setError(error.message || 'An error occurred during sign-up.');
    }
  };

  const handleSignUpConfirmation = async (e) => {
    e.preventDefault();

    try {
      await confirmSignUp({ username: email, confirmationCode: confirmCode });
      setMessage('Successful Sign Up! Please Sign In');
      setConfirmStatus(true);
    } catch (error) {
      setError(error.message || 'An error occurred during confirmation.');
      console.error('Error confirming sign-up:', error);
    }
  };


  const checkboxHandler = () => {
    setTermsAffirmed(!termsAffirmed)
  }

  return (
    <>
      <Container>
        <FormWrap>
          <FormContent>
            {verStatus ? (
              <>
                {confirmStatus ? (
                  <Form>
                    <Text>{message}</Text>
                    <NavBtnLink to='/signin'>Sign In</NavBtnLink>
                  </Form>
                ) :
                  <Form>
                    <FormH1>Check Email For Confirmation Code</FormH1>
                    <FormLabel htmlFor='for'>Confirmation Code</FormLabel>
                    <FormInput value={confirmCode} onChange={event => setConfirmCode(event.target.value)} required />
                    <Text>{error}</Text>
                    <FormButton type='submit' onClick={(e) => handleSignUpConfirmation(e)}>Submit</FormButton>
                  </Form>
                }
              </>
            ) :
              <Form action='#'>
                <FormH1>Create Account</FormH1>
                <FormLabel htmlFor='for'>Name</FormLabel>
                <FormInput value={name} onChange={event => setName(event.target.value)} required />
                <FormLabel htmlFor='for'>Email</FormLabel>
                <FormInput type='email' value={email} onChange={event => setEmail(event.target.value.toLowerCase())} required />
                {/* <FormLabel htmlFor='for'>Address</FormLabel>
                <FormInput value={address} onChange={event => setAddress(event.target.value)} required /> */}
                {/* <FormLabel htmlFor='for'>Phone Number (+5559998888)</FormLabel>
                <FormInput value={phoneNumber} onChange={event => setPhoneNumber(event.target.value)} required /> */}
                {/* <FormLabel htmlFor='for'>Username</FormLabel>
                <FormInput value={username} onChange={event => setUsername(event.target.value)} required /> */}
                <FormLabel htmlFor='for'>Password</FormLabel>
                <FormInput type='password' value={password} onChange={event => setPassword(event.target.value)} required />
                <FormLabel htmlFor='for'>Confrim Password</FormLabel>
                <FormInput type='password' value={confirmPassword} onChange={event => setConfirmPassword(event.target.value)} required />
                <SignUpTermsContainer>
                  <Checkbox type='checkbox' onChange={checkboxHandler}></Checkbox>
                  <CheckboxText to='/'>Agree to <a href='/termsofservice' target="_blank">Terms Of Service</a></CheckboxText>
                </SignUpTermsContainer>
                <FormButton type='submit' disabled={!termsAffirmed} onClick={(e) => handleSignUp(e)}>Sign Up</FormButton>
                <ErrorText>{error}</ErrorText>
                <Text>Already have an account?</Text>
                <NavBtnLink to='/signin'>Sign In</NavBtnLink>
              </Form>
            }
          </FormContent>
        </FormWrap>
      </Container>
    </>
  );
};

export default SignUp;
